// src/pages/Complete/FirstComplete.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../../assets/css/common.css';
import './complete.css';
import fofficialQR from '../../assets/images/mss-official-line.png';

function FirstComplete() {
  return (
    <div className="container">
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="complete-card text-center shadow rounded">
          <h1 className="text-center text-primary">登録完了</h1>
          <p className="thanks-message thanks-message01">お疲れ様でした</p>
          <p className="thanks-message thanks-message02">ご登録ありがとうございました！</p>

          <div className="line-section">
            <p>今後のお知らせはLINE公式アカウントから配信されます<br/>必ずご登録ください。</p>
            <p>QRからLINE公式を追加する</p>
              <p><img src={fofficialQR} alt="MSS LINE公式のQR" className="welcome-img mb-4"/></p>
            <a href="https://lin.ee/68NB4Kc" target="_blank" rel="noopener noreferrer" className="btn btn-line">リンクからLINE公式を追加する</a>
          </div>

          <div className="d-grid mt-4">
            <Link to="/" className="btn btn-primary btn-lg">マイページへ</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FirstComplete;
